import { initComponent } from './core/init-component';

// After a filter/sort change the result set is different, so the previous scroll position is
// meaningless: you would be looking at unrelated products or, with fewer results, at empty space
// below the grid. Scroll back to the top of the results so the new set is shown from the start.
// The filter bar is sticky, so it stays pinned at the top and filtering stays accessible.
//
// Triggered by the facets `filter:update` event (FilterUpdateEvent, bubbles), which fires on filter
// changes, sort changes and Clear all — from BOTH the desktop bar and the mobile drawer — but NOT on
// infinite scroll. We listen on the results-list because the dispatching facets-form-component is a
// descendant of it, so the event bubbles through.
initComponent('results-list', (resultsList) => {
  const scrollToResultsTop = () => {
    // Absolute flow top of the listing. Scrolling here pins the sticky filter bar at the viewport
    // top with the first products right beneath it.
    const top = resultsList.getBoundingClientRect().top + window.scrollY;

    // Only pull the viewport up; never push it down (e.g. when the user is already above the grid).
    if (window.scrollY <= top) return;

    // Smooth scroll, but honour reduced-motion (jump instantly for those users).
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: reduceMotion ? 'instant' : 'smooth' });
  };

  resultsList.addEventListener('filter:update', scrollToResultsTop);

  return {
    unload() {
      resultsList.removeEventListener('filter:update', scrollToResultsTop);
    },
  };
});
